module.exports = __webpack_public_path__ + "img/2-4.5be5309b.png";